export default "__VITE_ASSET__BsH2xfUD__"